module.exports = __webpack_public_path__ + "3c50ab4660136cc3dda6a01698955c9c.MP3";